import React from 'react';
import { Modal, Box, Typography, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Formik, Form, Field } from 'formik';
import { TextField as formikTextField } from 'formik-material-ui';
import { Form as RBFORM } from 'react-bootstrap';
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import { object, string } from 'yup';
import CloseIcon from "@mui/icons-material/Close";

import noteIcon from '../../../assets/images/noteIcon.svg';
import NoteIcon from '../../icons/NoteIcon';
import { postMethodFormData, putFormMethod } from "../../../services/apiService";

export interface AddSiteModalProps {
    addSiteModalOpen: boolean;
    handleAddSiteModalClose: () => void;
    siteEdit: boolean;
    siteInitialValues: any;
    country: string;
    state: string;
    city: string;
    customerTimeZone: string;
    siteId: any;
    customerData: any;
    isSearching: boolean;
    searchText: string;
    fetchCusomerSites: (enterpriseId: string) => Promise<void>;
    handleSearch: (text: string) => void;
    setToast: any;
    countryList: any[];
    filteredStateList: any[];
    filteredCityList: any[];
    timezoneList: any[];
    handleCountryChange: (e: any, setFieldValue: any) => void;
    handleStateChange: (e: any, setFieldValue: any) => void;
    handleCityChange: (e: any, setFieldValue: any) => void;
    handleTimeZoneChange: (e: any, setFieldValue: any) => void;
    customerEnterpriseId: string;
}

export const AddSiteModal: React.FC<AddSiteModalProps> = ({
    addSiteModalOpen, handleAddSiteModalClose, siteEdit, siteInitialValues,
    country, state, city, customerTimeZone, siteId, customerData,
    isSearching, searchText, fetchCusomerSites, handleSearch, setToast,
    countryList, filteredStateList, filteredCityList, timezoneList,
    handleCountryChange, handleStateChange, handleCityChange, handleTimeZoneChange,
    customerEnterpriseId
}) => {
    return (
        <Modal
            open={addSiteModalOpen}
            onClose={handleAddSiteModalClose}
            className="AddFeatureM"
        >
            <Box sx={{
                maxWidth: '736px',
                width: '100%',
                margin: '64px auto 0',
                padding: '24px',
                borderRadius: '30px',
                borderColor: '#5A5F60 !important',
                border: '1px solid',

            }}
            >
                <Typography variant="h6" component="h2" gutterBottom
                    sx={{
                        fontSize: '20px',
                        color: '#E2E3E3',
                        borderBottom: '1px solid #5A5F60',
                        paddingBottom: '10px',
                        marginBottom: '30px',
                    }}
                >
                    {!siteEdit ? "Add New Site / Device" : "Edit Site / Device Info"}
                    <span onClick={handleAddSiteModalClose}><CloseIcon style={{ float: "right", cursor: "pointer" }}></CloseIcon></span>
                </Typography>

                <Formik
                    initialValues={siteInitialValues}
                    enableReinitialize={true} // Enable reinitialization
                    validationSchema={object({
                        enterpriseid: string().trim().required("Enterpriseid is required!"),
                        name: string().trim().required("Site name / device is required!"),
                        uniqueid: string().trim().required("Unique ID is required!"),
                        email: string().email().required("Email ID is required!"),
                        type: string().required("Type is required!"),
                        addressline1: string().trim().optional(),
                        addressline2: string().trim().optional(),
                        postalcode: string().trim().optional(),
                        city: string().nullable().optional(),
                        state: string().nullable().optional(),
                        country: string().nullable().optional(),
                        number: string().min(2, "Must be at least 2 digits").max(10, "Cannot be more than 10 digits").optional(),
                        mobile: string().trim().optional(),
                        timezone: string().nullable().optional(),
                    })}
                    onSubmit={async (values, { setSubmitting }) => {
                        try{
                        let temp_values: any = { ...values };
                        temp_values.country = country;
                        temp_values.state = state;
                        temp_values.city = city;
                        temp_values.timezone = customerTimeZone;
                        // delete temp_values['uniqueid'];

                        if (temp_values?.mobile != "" && !temp_values.mobile?.includes("+")) {
                            temp_values = { ...temp_values, mobile: `+${temp_values.mobile}` }
                        }

                        
                        let api_endpoint = "";
                        let resp;
                        if (!siteEdit) {
                            api_endpoint = `customer/site`;
                            resp = await postMethodFormData(api_endpoint, temp_values);
                        } else {
                            api_endpoint = `customer/site/${siteId}`;
                            resp = await putFormMethod(api_endpoint, temp_values);
                        }

                        if (resp?.status === 200) {
                            if(!isSearching) {
                                if (customerData?.customer?.vEnterprise?.enterpriseid) {
                                    await fetchCusomerSites(customerData?.customer?.vEnterprise?.enterpriseid);
                                }
                            } else {
                                handleSearch(searchText);
                            }
                            setToast(resp?.data?.message, "success");
                            handleAddSiteModalClose();
                        } else {
                            setToast(resp?.data?.message, "error");
                        }
                    }
                        catch (err) {
                            console.error("SUBMIT ERROR", err);
                        } finally {
                            setSubmitting(false);  
                        }
                }}
                >
                    {({ values, isSubmitting, setFieldValue, errors, touched }) => (

                        
                        <>
                        <Form>
                            <Grid container spacing={2} className="customer_popup" style={{ paddingBottom: "30px", paddingRight: "8px" }}>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <RBFORM.Group>
                                        <Typography variant="subtitle1"
                                            sx={{
                                                color: '#B4B7B8',
                                                fontSize: '14px',
                                            }}
                                        > Site / Device Name<span style={{ color: "red" }}>*</span></Typography>
                                        <Field
                                            name="name"
                                            as="input"
                                            type="text"
                                            component={formikTextField}
                                            className="inputC"
                                            placeholder="Enter Site / Sevice Name"
                                        />
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <RBFORM.Group>
                                        <Typography variant="subtitle1"
                                            sx={{
                                                color: '#B4B7B8',
                                                fontSize: '14px',
                                            }}
                                        > Unique ID<span style={{ color: "red" }}>*</span></Typography>
                                        <Field
                                            name="uniqueid"
                                            as="input"
                                            type="text"
                                            component={formikTextField}
                                            className="inputC"
                                            placeholder="Enter Unique ID"
                                        />
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <RBFORM.Group>
                                        <Typography variant="subtitle1"
                                            sx={{
                                                color: '#B4B7B8',
                                                fontSize: '14px',
                                            }}
                                        > Type<span style={{ color: "red" }}>*</span></Typography>
                                        <Field
                                            name="type"
                                            as="select"
                                            placeholder="type"
                                            className="inputC custDropdown"
                                        >
                                            <option value="EDGE">EDGE</option>
                                            <option value="CLOUD">CLOUD</option>
                                        </Field>
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <RBFORM.Group>
                                        <Typography variant="subtitle1"
                                            sx={{
                                                color: '#B4B7B8',
                                                fontSize: '14px',
                                            }}
                                        > Email ID<span style={{ color: "red" }}>*</span></Typography>
                                        <Field
                                            name="email"
                                            type="text"
                                            component={formikTextField}
                                            className="inputC"
                                            placeholder="Enter Email ID"
                                        />
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 12 }}>
                                    <RBFORM.Group>
                                        <Typography variant="subtitle1"
                                            sx={{
                                                color: '#B4B7B8',
                                                fontSize: '14px',
                                            }}
                                        > Address Line 1</Typography>
                                        <Field
                                            name="addressline1"
                                            as="input"
                                            type="text"
                                            component={formikTextField}
                                            className="inputC"
                                            placeholder="Street address / company name / c/o"
                                        />

                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 12 }}>
                                    <RBFORM.Group>
                                        <Typography variant="subtitle1"
                                            sx={{
                                                color: '#B4B7B8',
                                                fontSize: '14px',
                                            }}
                                        > Address Line 2</Typography>
                                        <Field
                                            name="addressline2"
                                            as="input"
                                            type="text"
                                            component={formikTextField}
                                            className="inputC"
                                            placeholder="Apartment / unit / building"
                                        />
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Country</RBFORM.Label>
                                        <Field
                                            name="country"
                                            as="select"
                                            className="inputC custDropdown"
                                            onChange={(e: any) => handleCountryChange(e, setFieldValue)}
                                        >
                                            {countryList?.length > 0 ? (
                                                countryList.map((country: any) => (
                                                    <option key={country.id} value={country.id}>
                                                        {country.name}
                                                    </option>
                                                ))
                                            ) : (
                                                <option>Select Country</option>
                                            )}
                                        </Field>
                                    </RBFORM.Group>
                                </Grid>


                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">State</RBFORM.Label>
                                        <Field
                                            name="state"
                                            as="select"
                                            placeholder="State"
                                            className="inputC custDropdown"
                                            onChange={(e: any) => handleStateChange(e, setFieldValue)}
                                        >
                                            {filteredStateList?.length > 0 ? (
                                                <>
                                                    <option>Select State</option>
                                                    {filteredStateList.map((state: any) => (
                                                        <option key={state.id} value={state.id}>
                                                            {state.name}
                                                        </option>
                                                    ))}
                                                </>
                                            ) : (
                                                <option>Select State</option>
                                            )}
                                        </Field>
                                    </RBFORM.Group>
                                </Grid>


                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">City</RBFORM.Label>
                                        <Field
                                            name="city"
                                            as="select"
                                            placeholder="City"
                                            className="inputC custDropdown"
                                            onChange={(e: any) => handleCityChange(e, setFieldValue)}
                                        >
                                            {filteredCityList?.length > 0 ? (
                                                <>
                                                    <option>Select City</option>
                                                    {filteredCityList.map((city: any) => (
                                                        <option key={city.id} value={city.id}>
                                                            {city.name}
                                                        </option>
                                                    ))}
                                                </>
                                            ) : (
                                                <option>Select City</option>
                                            )}
                                        </Field>
                                    </RBFORM.Group>
                                </Grid>


                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Postal Code</RBFORM.Label>
                                        <Field
                                            name="postalcode"
                                            type="text"
                                            placeholder="Enter Postal Code"
                                            component={formikTextField}
                                            className="inputC"
                                        />
                                    </RBFORM.Group>
                                </Grid>


                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Phone Number</RBFORM.Label>
                                        <Field
                                            name="number"
                                            type="text"
                                            placeholder="Enter Phone Number"
                                            component={formikTextField}
                                            className="inputC"
                                        />
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Mobile Number</RBFORM.Label>
                                        <PhoneInput
                                            country={'us'}
                                            specialLabel=""
                                            dropdownClass="user-phone-input-dropdown"
                                            containerClass="user-phone-input-container"
                                            inputClass={`${errors.mobile ? "errors" : ""} modalForm-input user-phone-input`}
                                            inputStyle={{
                                                boxShadow: 'none',
                                                color: "#A5A8A9",
                                                border: "1px solid #313838 !important",
                                                width: "100%",
                                                height: "40px",
                                                backgroundColor: "#192529",
                                            }}
                                            placeholder="Enter Mobile Number"
                                            value={values.mobile}
                                            onChange={(number) => setFieldValue("mobile", number)}
                                        />
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, md: 12 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Timezone</RBFORM.Label>
                                        <Field
                                            name="timezone"
                                            as="select"
                                            className="inputC custDropdown"
                                            onChange={(e: any) => handleTimeZoneChange(e, setFieldValue)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <option disabled>Select</option>
                                            {timezoneList.map((tz: any) => (
                                                <option key={tz.value} value={tz.value}>
                                                    {tz.label}
                                                </option>
                                            ))}

                                        </Field>
                                    </RBFORM.Group>
                                </Grid>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <span>
                                        {/* <img src={noteIcon} style={{ width: "20px", height: "20px" }} /> */}
                                        <NoteIcon />
                                    </span>
                                    <span
                                        className="label"
                                        style={{ marginLeft: "8px", marginTop: "1.5px", fontSize: "14px", fontWeight: "400" }}
                                    >
                                        Note: If the timezone is not set at the site level, it will default to the customer’s timezone. If the customer’s timezone is also not set, UTC time will be set as default
                                    </span>
                                </div>

                            </Grid>

                            <Field
                                name="enterpriseid"
                                type="hidden"
                                placeholder="Enter Phone Number"
                                component={formikTextField}
                                className="inputC"
                                style={{ display: "none" }}
                                value={customerEnterpriseId}
                            />

                            {/* <input type="text" name="enterpriseid" value={customerEnterpriseId} /> */}
                            {/* {JSON.stringify(values, null, 2)} */}



                            <Box sx={{ display: "flex", borderTop: "1px solid #5A5F60", paddingTop: '20px', justifyContent: "flex-end", gap: 2 }}>
                                <Button type="button" onClick={handleAddSiteModalClose} variant="outlined" className="hoverBtn"
                                    sx={{ color: '#0699CE', textTransform: 'capitalize', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWeight: '500', }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    disabled={isSubmitting}
                                    sx={{
                                        color: '#1F2F34', height: '41px', lineHeight: '41px',
                                        borderColor: '#0B4A62', background: '#17B2EB',
                                        borderRadius: '25px', fontSize: '14px',
                                        fontWeight: '500',
                                        textTransform: 'capitalize',
                                    }}
                                >
                                    Save Changes
                                </Button>
                            </Box>
                        </Form>

                        {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
                        </>
                    )}
                </Formik>
            </Box>
        </Modal>
    );
};